import React, { useState } from "react";
import PartnerSignupForm from "../components/Partner/PartnerSignupForm";
import PartnerFooter from "../components/Partner/PartnerFooter";
import PartnerSidebar from "../components/Partner/PartnerSidebar";
import TopBanner from "../components/Partner/TopBanner";
import Header from "../components/Partner/Header";
import HeroSection from "../components/Partner/HeroSection";
import PartnersSection from "../components/Partner/PartnersSection";
import WhySection from "../components/Partner/WhySection";
import CaseStudiesSection from "../components/Partner/CaseStudiesSection";
import HowItWorksSection from "../components/Partner/HowItWorksSection";
// import HowItWorks3 from "../assets/how-it-works-3.png";

export default function Partners() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div
      className="bg-[#1D1726] min-h-screen"
      style={{
        background:
          "linear-gradient(to bottom, #0B0415 0%, #1d0630 40vh, #2a0744 60vh)",
      }}
    >
      <TopBanner />
      <div className="p-[20px] min-h-screen">
        <div className="mx-auto max-w-[1160px]">
          <Header setSidebarOpen={setSidebarOpen} />
          <HeroSection />
          <PartnersSection />

          <WhySection />
          <CaseStudiesSection />

          <HowItWorksSection />
        </div>
      </div>
      <div className="!overflow-hidden">
        <section
          id="signup"
          className="bg-[#0B0415D9] max-md:p-[40px_16px] md:py-[64px] border-[#292433] border-[1.5px] overflow-hidden"
        >
          <div className="font-semibold text-white max-md:text-[22px] md:text-[32px] text-center max-md:leading-[26px] md:leading-[36px] md:tracking-[-1px]">
            Ready to go live?
          </div>
          <PartnerSignupForm />
        </section>
        <PartnerFooter />
        <PartnerSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      </div>
    </div>
  );
}
